import Alert from '@mui/joy/Alert'
import React, { useRef } from 'react'

export default function AlertWithAutoFocus (props) {
  // Create a ref for the Alert component
  const alertRef = useRef(null)

  // Use useEffect to focus the alert when it is mounted
  React.useEffect(() => {
    if (alertRef.current) {
      // alertRef.current.focus();
      alertRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }
  }, [])

  return <Alert ref={alertRef} {...props} />
}
